module.exports = __webpack_public_path__ + "fonts/SFUIText-Regular.f040f132.ttf";